function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import NotRepresentableException from './NotRepresentableException';
import Coordinate from '../geom/Coordinate';
import Orientation from './Orientation';
import CGAlgorithmsDD from './CGAlgorithmsDD';
import System from '../../../../java/lang/System';
import HCoordinate from './HCoordinate';
import Envelope from '../geom/Envelope';
import Distance from './Distance';
import LineIntersector from './LineIntersector';
var RobustLineIntersector = /*#__PURE__*/function (_LineIntersector) {
  function RobustLineIntersector() {
    var _this;
    _classCallCheck(this, RobustLineIntersector);
    _this = _callSuper(this, RobustLineIntersector);
    RobustLineIntersector.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(RobustLineIntersector, _LineIntersector);
  return _createClass(RobustLineIntersector, [{
    key: "isInSegmentEnvelopes",
    value: function isInSegmentEnvelopes(intPt) {
      var env0 = new Envelope(this._inputLines[0][0], this._inputLines[0][1]);
      var env1 = new Envelope(this._inputLines[1][0], this._inputLines[1][1]);
      return env0.contains(intPt) && env1.contains(intPt);
    }
  }, {
    key: "computeIntersection",
    value: function computeIntersection() {
      if (arguments.length === 3) {
        var p = arguments[0];
        var p1 = arguments[1];
        var p2 = arguments[2];
        this._isProper = false;
        if (Envelope.intersects(p1, p2, p)) {
          if (Orientation.index(p1, p2, p) === 0 && Orientation.index(p2, p1, p) === 0) {
            this._isProper = true;
            if (p.equals(p1) || p.equals(p2)) {
              this._isProper = false;
            }
            this._result = LineIntersector.POINT_INTERSECTION;
            return null;
          }
        }
        this._result = LineIntersector.NO_INTERSECTION;
      } else return _superPropGet(RobustLineIntersector, "computeIntersection", this, 1).apply(this, arguments);
    }
  }, {
    key: "normalizeToMinimum",
    value: function normalizeToMinimum(n1, n2, n3, n4, normPt) {
      normPt.x = this.smallestInAbsValue(n1.x, n2.x, n3.x, n4.x);
      normPt.y = this.smallestInAbsValue(n1.y, n2.y, n3.y, n4.y);
      n1.x -= normPt.x;
      n1.y -= normPt.y;
      n2.x -= normPt.x;
      n2.y -= normPt.y;
      n3.x -= normPt.x;
      n3.y -= normPt.y;
      n4.x -= normPt.x;
      n4.y -= normPt.y;
    }
  }, {
    key: "safeHCoordinateIntersection",
    value: function safeHCoordinateIntersection(p1, p2, q1, q2) {
      var intPt = null;
      try {
        intPt = HCoordinate.intersection(p1, p2, q1, q2);
      } catch (e) {
        if (e instanceof NotRepresentableException) {
          intPt = RobustLineIntersector.nearestEndpoint(p1, p2, q1, q2);
        } else throw e;
      } finally {}
      return intPt;
    }
  }, {
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var intPt = this.intersectionWithNormalization(p1, p2, q1, q2);
      if (!this.isInSegmentEnvelopes(intPt)) {
        intPt = new Coordinate(RobustLineIntersector.nearestEndpoint(p1, p2, q1, q2));
      }
      if (this._precisionModel !== null) {
        this._precisionModel.makePrecise(intPt);
      }
      return intPt;
    }
  }, {
    key: "smallestInAbsValue",
    value: function smallestInAbsValue(x1, x2, x3, x4) {
      var x = x1;
      var xabs = Math.abs(x);
      if (Math.abs(x2) < xabs) {
        x = x2;
        xabs = Math.abs(x2);
      }
      if (Math.abs(x3) < xabs) {
        x = x3;
        xabs = Math.abs(x3);
      }
      if (Math.abs(x4) < xabs) {
        x = x4;
      }
      return x;
    }
  }, {
    key: "checkDD",
    value: function checkDD(p1, p2, q1, q2, intPt) {
      var intPtDD = CGAlgorithmsDD.intersection(p1, p2, q1, q2);
      var isIn = this.isInSegmentEnvelopes(intPtDD);
      System.out.println('DD in env = ' + isIn + '  --------------------- ' + intPtDD);
      if (intPt.distance(intPtDD) > 0.0001) {
        System.out.println('Distance = ' + intPt.distance(intPtDD));
      }
    }
  }, {
    key: "intersectionWithNormalization",
    value: function intersectionWithNormalization(p1, p2, q1, q2) {
      var n1 = new Coordinate(p1);
      var n2 = new Coordinate(p2);
      var n3 = new Coordinate(q1);
      var n4 = new Coordinate(q2);
      var normPt = new Coordinate();
      this.normalizeToEnvCentre(n1, n2, n3, n4, normPt);
      var intPt = this.safeHCoordinateIntersection(n1, n2, n3, n4);
      intPt.x += normPt.x;
      intPt.y += normPt.y;
      return intPt;
    }
  }, {
    key: "computeCollinearIntersection",
    value: function computeCollinearIntersection(p1, p2, q1, q2) {
      var p1q1p2 = Envelope.intersects(p1, p2, q1);
      var p1q2p2 = Envelope.intersects(p1, p2, q2);
      var q1p1q2 = Envelope.intersects(q1, q2, p1);
      var q1p2q2 = Envelope.intersects(q1, q2, p2);
      if (p1q1p2 && p1q2p2) {
        this._intPt[0] = q1;
        this._intPt[1] = q2;
        return LineIntersector.COLLINEAR_INTERSECTION;
      }
      if (q1p1q2 && q1p2q2) {
        this._intPt[0] = p1;
        this._intPt[1] = p2;
        return LineIntersector.COLLINEAR_INTERSECTION;
      }
      if (p1q1p2 && q1p1q2) {
        this._intPt[0] = q1;
        this._intPt[1] = p1;
        return q1.equals(p1) && !p1q2p2 && !q1p2q2 ? LineIntersector.POINT_INTERSECTION : LineIntersector.COLLINEAR_INTERSECTION;
      }
      if (p1q1p2 && q1p2q2) {
        this._intPt[0] = q1;
        this._intPt[1] = p2;
        return q1.equals(p2) && !p1q2p2 && !q1p1q2 ? LineIntersector.POINT_INTERSECTION : LineIntersector.COLLINEAR_INTERSECTION;
      }
      if (p1q2p2 && q1p1q2) {
        this._intPt[0] = q2;
        this._intPt[1] = p1;
        return q2.equals(p1) && !p1q1p2 && !q1p2q2 ? LineIntersector.POINT_INTERSECTION : LineIntersector.COLLINEAR_INTERSECTION;
      }
      if (p1q2p2 && q1p2q2) {
        this._intPt[0] = q2;
        this._intPt[1] = p2;
        return q2.equals(p2) && !p1q1p2 && !q1p1q2 ? LineIntersector.POINT_INTERSECTION : LineIntersector.COLLINEAR_INTERSECTION;
      }
      return LineIntersector.NO_INTERSECTION;
    }
  }, {
    key: "normalizeToEnvCentre",
    value: function normalizeToEnvCentre(n00, n01, n10, n11, normPt) {
      var minX0 = n00.x < n01.x ? n00.x : n01.x;
      var minY0 = n00.y < n01.y ? n00.y : n01.y;
      var maxX0 = n00.x > n01.x ? n00.x : n01.x;
      var maxY0 = n00.y > n01.y ? n00.y : n01.y;
      var minX1 = n10.x < n11.x ? n10.x : n11.x;
      var minY1 = n10.y < n11.y ? n10.y : n11.y;
      var maxX1 = n10.x > n11.x ? n10.x : n11.x;
      var maxY1 = n10.y > n11.y ? n10.y : n11.y;
      var intMinX = minX0 > minX1 ? minX0 : minX1;
      var intMaxX = maxX0 < maxX1 ? maxX0 : maxX1;
      var intMinY = minY0 > minY1 ? minY0 : minY1;
      var intMaxY = maxY0 < maxY1 ? maxY0 : maxY1;
      var intMidX = (intMinX + intMaxX) / 2.0;
      var intMidY = (intMinY + intMaxY) / 2.0;
      normPt.x = intMidX;
      normPt.y = intMidY;
      n00.x -= normPt.x;
      n00.y -= normPt.y;
      n01.x -= normPt.x;
      n01.y -= normPt.y;
      n10.x -= normPt.x;
      n10.y -= normPt.y;
      n11.x -= normPt.x;
      n11.y -= normPt.y;
    }
  }, {
    key: "computeIntersect",
    value: function computeIntersect(p1, p2, q1, q2) {
      this._isProper = false;
      if (!Envelope.intersects(p1, p2, q1, q2)) return LineIntersector.NO_INTERSECTION;
      var Pq1 = Orientation.index(p1, p2, q1);
      var Pq2 = Orientation.index(p1, p2, q2);
      if (Pq1 > 0 && Pq2 > 0 || Pq1 < 0 && Pq2 < 0) {
        return LineIntersector.NO_INTERSECTION;
      }
      var Qp1 = Orientation.index(q1, q2, p1);
      var Qp2 = Orientation.index(q1, q2, p2);
      if (Qp1 > 0 && Qp2 > 0 || Qp1 < 0 && Qp2 < 0) {
        return LineIntersector.NO_INTERSECTION;
      }
      var collinear = Pq1 === 0 && Pq2 === 0 && Qp1 === 0 && Qp2 === 0;
      if (collinear) {
        return this.computeCollinearIntersection(p1, p2, q1, q2);
      }
      if (Pq1 === 0 || Pq2 === 0 || Qp1 === 0 || Qp2 === 0) {
        this._isProper = false;
        if (p1.equals2D(q1) || p1.equals2D(q2)) {
          this._intPt[0] = p1;
        } else if (p2.equals2D(q1) || p2.equals2D(q2)) {
          this._intPt[0] = p2;
        } else if (Pq1 === 0) {
          this._intPt[0] = new Coordinate(q1);
        } else if (Pq2 === 0) {
          this._intPt[0] = new Coordinate(q2);
        } else if (Qp1 === 0) {
          this._intPt[0] = new Coordinate(p1);
        } else if (Qp2 === 0) {
          this._intPt[0] = new Coordinate(p2);
        }
      } else {
        this._isProper = true;
        this._intPt[0] = this.intersection(p1, p2, q1, q2);
      }
      return LineIntersector.POINT_INTERSECTION;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RobustLineIntersector;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "nearestEndpoint",
    value: function nearestEndpoint(p1, p2, q1, q2) {
      var nearestPt = p1;
      var minDist = Distance.pointToSegment(p1, q1, q2);
      var dist = Distance.pointToSegment(p2, q1, q2);
      if (dist < minDist) {
        minDist = dist;
        nearestPt = p2;
      }
      dist = Distance.pointToSegment(q1, p1, p2);
      if (dist < minDist) {
        minDist = dist;
        nearestPt = q1;
      }
      dist = Distance.pointToSegment(q2, p1, p2);
      if (dist < minDist) {
        minDist = dist;
        nearestPt = q2;
      }
      return nearestPt;
    }
  }]);
}(LineIntersector);
export { RobustLineIntersector as default };
RobustLineIntersector.constructor_ = function () {};